import { OrderDetailsProduct } from '@savgroup-front-common/types';

interface AdaptProductsEligibilityArgs {
  products: OrderDetailsProduct[];
  eligibleOwnerProductIds?: string[];
}

interface ProductsEligibility {
  eligibleProducts: OrderDetailsProduct[];
  notEligibleProducts: OrderDetailsProduct[];
  notEligibleProductsFollowUpClaim: OrderDetailsProduct[];
}

export const adaptProductsEligibility = ({
  products,
  eligibleOwnerProductIds,
}: AdaptProductsEligibilityArgs): ProductsEligibility => {
  const issueProducts = products.filter((product) =>
    eligibleOwnerProductIds?.includes(product.ownerProductId),
  );

  const eligibleProducts = issueProducts.filter(
    (product) => product.isAvailableForClaims,
  );

  const notEligibleProducts = issueProducts.filter(
    (product) => !product.isAvailableForClaims && !product.claimGroupId,
  );

  const notEligibleProductsFollowUpClaim = issueProducts.filter(
    (product) => !product.isAvailableForClaims && product.claimGroupId,
  );

  return {
    eligibleProducts,
    notEligibleProducts,
    notEligibleProductsFollowUpClaim,
  };
};
